import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange } from '@angular/core';
import moment from 'moment-timezone';

@Component({
    selector: 'lf-countdown',
    template: `{{timer}}`,
})
export class CountdownComponent implements OnChanges
{
    @Input()
    public units: any;

    // Timer end time.
    @Input()
    public end: any;

    // Actual timer value being displayed.
    @Input()
    public timer: string = '';

    // Set to override default English locale text for units.
    @Input()
    public text: any = {
        Weeks: 'Weeks',
        Days: 'Days',
        Hours: 'Hours',
        Minutes: 'Minutes',
        Seconds: 'Seconds',
        Milliseconds: 'Milliseconds',
    };

    @Output()
    public zeroReached: EventEmitter<null> = new EventEmitter<null>();

    constructor() {
        this.startTimer();
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        // This change event fires for the first time when the control is passed into the directive.
        if (changes.hasOwnProperty('end')) {
            this.end = changes['end'].currentValue;
            this.startTimer();
        }
    }

    public startTimer() {
        setTimeout(() => {
            this.setTimerString();
        }, 1);
    }

    public setTimerString() {
        if (typeof this.units === 'string') {
            this.units = this.units.split('|').map(function (unit) {
                return unit.trim();
            });
        }

        const givenDate: any = moment.isMoment(this.end) ? this.end.toDate() : new Date(this.end);
        const now: any = new Date();

        const dateDifference: any = givenDate - now;
        const lastUnit: any = this.units[this.units.length - 1];
        const unitConstantsInMs: any = {
            weeks: 604800000,
            days: 86400000,
            hours: 3600000,
            minutes: 60000,
            seconds: 1000,
            milliseconds: 1,
        };
        const unitsLeft: any = {};
        let returnString = '';
        let totalMsLeft = dateDifference;

        for (let unit of this.units) {
            unit = unit.trim();

            if (unitConstantsInMs[unit.toLowerCase()] === false) {
                throw new Error('Cannot repeat unit: ' + unit);
            }

            if (unitConstantsInMs.hasOwnProperty(unit.toLowerCase()) === false) {
                throw new Error('Unit: ' + unit + ' is not supported. Please use following unit values: weeks, days, hours, minutes, seconds, milliseconds.');
            }

            unitsLeft[unit] = totalMsLeft / unitConstantsInMs[unit.toLowerCase()];

            if (lastUnit === unit) {
                unitsLeft[unit] = Math.ceil(unitsLeft[unit]);
            } else {
                unitsLeft[unit] = Math.floor(unitsLeft[unit]);
            }

            totalMsLeft -= unitsLeft[unit] * unitConstantsInMs[unit.toLowerCase()];
            unitConstantsInMs[unit.toLowerCase()] = false;

            returnString += ' ' + unitsLeft[unit] + ' ' + unit;
        }

        if (dateDifference < 0) {
            this.zeroReached.emit(null);
            this.timer = 'Now';
        } else {
            this.startTimer();

            // Replace units with stored verbiage version.
            this.timer = returnString.replace(
                    'Weeks', this.text.Weeks,
            ).replace(
                    'Days', this.text.Days,
            ).replace(
                    'Hours', this.text.Hours,
            ).replace(
                    'Minutes', this.text.Minutes,
            ).replace(
                    'Seconds', this.text.Seconds,
            ).replace(
                    'Milliseconds', this.text.Milliseconds,
            );
        }
    }
}
